import React, { useState } from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';

const PopoverNotice = (props) => {

    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggle = () => setPopoverOpen(!popoverOpen);

    return (
        <Popover trigger={props.trigger} placement={props.placement} isOpen={popoverOpen} target={props.target} toggle={toggle}>
            <PopoverHeader>{props.title}</PopoverHeader>
            <PopoverBody>{props.body}</PopoverBody>
        </Popover>
    );

}

export default PopoverNotice;